import { render, staticRenderFns } from "./RegistrationSection.vue?vue&type=template&id=4e478a4d&scoped=true&"
import script from "./RegistrationSection.vue?vue&type=script&lang=js&"
export * from "./RegistrationSection.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationSection.vue?vue&type=style&index=0&id=4e478a4d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e478a4d",
  null
  
)

export default component.exports